import React, { useState } from "react";
import Modal from "react-modal";
import { Notes } from "./common/Notes";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "350px",
        width: "100%",
        padding: "30px",
        fontSize: "20px",
    },
};


export const WarningModal = ({ isOpen, message, onHide}) => {  
   
    return (
        <div>
          
            <Modal isOpen={isOpen} style={customStyles} contentLabel="APU">               
                <div class="form_styl">
                                <div class="w100">
                                  <Notes name={message} size={"0.72rem"} />
                                </div>
                              </div>
                <br />
                <div className="">
                    <button className='submit' onClick={onHide}>OK</button>
                   </div>

            </Modal>
        </div>
    );
};